import * as React from 'react';
import { Venues } from '@weddingspot/ws-api-client';

import styles from './Packages.module.scss';

export interface PackagesProps {
    packages: Venues.VenuePackage[];
}

const Packages = ({ packages }: PackagesProps) => {
    return (
        <div className='Packages'>
            {packages.map((pkg, idx) => {
                return (
                    <div className={styles.PackagesRow} key={idx}>
                        <div className={styles.PackagesRowHeader}>{pkg.title}</div>
                        <div className={styles.PackagesRowSubhead}>{pkg.starting_price}</div>
                        <div className={styles.PackagesRowDescription}>
                            {pkg.description.split('\r\n').map((item, idx) => {
                                return <p key={idx}>{item}</p>;
                            })}
                        </div>
                        <div className={styles.PackagesRowCTA}>
                            <a href={pkg.content_link} target='_blank' className='nx-button nx-button--primary'>
                                View Package
                            </a>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Packages;
